<script setup lang="ts">
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import Divider from '@/components/common/divider.vue';

interface Props {
  relatedQuestions: Array<string>;
  enableVisasqNowButton: boolean;
}
const emit = defineEmits<{
  'select-question': [selectedQuestion: string];
  'select-visasq-now': [];
}>();
const props = defineProps<Props>();
</script>
<template>
  <div class="survey-related-questions-container">
    <div class="survey-related-questions-header">関連質問</div>
    <div class="spacing-08" />
    <div class="survey-related-questions-content">
      <div v-for="(question, i) in props.relatedQuestions" :key="i">
        <Divider />
        <div class="survey-related-questions-item">
          <div>
            {{ question }}
          </div>
          <button
            class="c-btn c-btnOutline small"
            @click="emit('select-question', question)"
          >
            <DgrIcon
              size="small"
              :keep-fill="false"
              name="sparkles-fill"
              class="ai-icon"
            />
            生成
          </button>
        </div>
      </div>
      <template v-if="props.enableVisasqNowButton">
        <Divider />
        <div class="visasq-now-item survey-related-questions-item">
          <div class="image-and-text">
            <img
              class="visasq-now-logo"
              src="@/assets/logo_visasq_now.png"
              alt="ビザスクnowのロゴ"
            />
            <p class="with-tooltip-annotation">
              業界のエキスパートに質問するための依頼文を生成する
              <VTooltip
                placement="top"
                :popper-triggers="['hover', 'focus']"
                :delay="{ show: 0, hide: 200 }"
              >
                <DgrIcon name="info" size="small" />
                <template #popper>
                  <div class="popper-container c-text-regular--s">
                    <span>
                      ビザスクnowは専門家に短時間で質問できるQ&A形式のスポットコンサルサービスです。
                      詳しくは
                      <a
                        href="https://visasq.co.jp/service/now?utm_source=stockmark&utm_medium=referral&utm_campaign=now"
                        target="_blank"
                        rel="noopener noreferrer"
                        >こちら
                      </a>
                    </span>
                  </div>
                </template>
              </VTooltip>
            </p>
          </div>
          <button
            class="c-btn c-btnOutline small"
            @click="emit('select-visasq-now')"
          >
            <DgrIcon
              size="small"
              :keep-fill="false"
              name="sparkles-fill"
              class="ai-icon"
            />
            生成
          </button>
        </div>
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.survey-related-questions-container {
  background-color: $color-white;
  padding: 16px 16px 0 16px;
  border-radius: 4px;
  border: solid 1px $color-gray400;
}
.survey-related-questions-header {
  font-size: 14px;
}
.survey-related-questions-content {
  padding: 8px 0;
}
.survey-related-questions-item {
  padding: 16px 0;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
}
button {
  width: 78px;
  white-space: nowrap;
  font-size: 12px;
  padding: 5px 16px;
}
.ai-icon {
  margin-right: 4px;
}
.visasq-now-logo {
  max-width: 120px;
  height: auto;
}
.with-tooltip-annotation {
  display: flex;
  align-items: center;
}
.popper-container {
  max-width: 304px;
  padding: 0px 4px;
  a {
    text-decoration: underline;
  }
}
</style>
